// Base
import React from "react";
import PropTypes from "prop-types";

// Styles
import styles from "./Price.scss";

export default function PriceText(props) {
  const { children, variants, ...restProps } = props;

  let parsedVariants = variants;

  if (!variants) {
    parsedVariants = styles.text;
  }

  if (typeof parsedVariants !== "string") {
    parsedVariants = variants.join(" ");
  }

  return (
    <p className={parsedVariants} {...restProps}>
      {children}
    </p>
  );
}

// Props
PriceText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

PriceText.defaultProps = {
  variants: "",
};

PriceText.Variant = {
  benefit: styles.textBenefit,
};

PriceText.displayName = "Price.Text";
